import { render, staticRenderFns } from "./HardwareBadge.vue?vue&type=template&id=500a50d1&"
import script from "./HardwareBadge.vue?vue&type=script&lang=js&"
export * from "./HardwareBadge.vue?vue&type=script&lang=js&"
import style0 from "./HardwareBadge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports